import { KeyboardArrowDown } from '@mui/icons-material'
import { Box } from '@mui/material'
import React from 'react'
import { sanitizeCell } from '../Utilities/tools'
import VocabularyTools, { DisplayTool } from './VocabularyTools'
import { useTranslation } from 'react-i18next'
import { ICard } from '../Store/GameSlice'

interface CardDisplayProps {
  currentCard: ICard
  loaded: boolean
  coverPosition: string
  interactionState: string
  showSecret: () => void
  setEditInfo: React.Dispatch<React.SetStateAction<string>>
  setEditSecret: React.Dispatch<React.SetStateAction<string>>
  displayTools: DisplayTool
  infoLanguage: string
  secretLanguage: string
}

const CardsPlayCardDisplay: React.FC<CardDisplayProps> = (
  {
    currentCard,
    loaded,
    coverPosition,
    interactionState,
    showSecret,
    setEditInfo,
    setEditSecret,
    displayTools,
    infoLanguage,
    secretLanguage,
  }) => {
  const { t } = useTranslation()

  const mockVocabulary = {
    rows: [{ left: currentCard.info, right: currentCard.secret }],
    left_language: infoLanguage,
    right_language: secretLanguage,
  }

  return (
    <div className="display">
      {!loaded && (
        <div className="card-container">
          <Box display="flex" justifyContent="center">
            {t('cardShow.loading')}
          </Box>
        </div>
      )}
      <div className={`card-container`}>
        <div className="card shadow2"></div>
        <div className="card shadow1"></div>
        <div className="card inner">
          <div className="info" data-testid="info">
            {interactionState !== 'edit' &&
              <div
                className="displayed-value"
                lang={infoLanguage}
                dangerouslySetInnerHTML={{
                  __html: sanitizeCell(currentCard.info),
                }}
              />}
            {interactionState === 'edit' &&
              <div
                className="displayed-value"
                lang={infoLanguage}
                contentEditable={interactionState === 'edit'}
                suppressContentEditableWarning
                dangerouslySetInnerHTML={{
                  __html: sanitizeCell(currentCard.info),
                }}
                onBlur={(e) => setEditInfo(sanitizeCell(e.target.innerHTML))}
              />
            }
            <VocabularyTools
              rowIndex={0}
              side="left"
              vocabulary={mockVocabulary}
              readOnly={interactionState !== 'edit'}
              displayTools={displayTools}
              onTranslationResult={setEditInfo}
            />
          </div>
          <div className="secret" data-testid="secret">
            {interactionState !== 'edit' &&
              <div
                className="displayed-value"
                lang={secretLanguage}
                dangerouslySetInnerHTML={{
                  __html: sanitizeCell(currentCard.secret),
                }}
              />}
            {interactionState === 'edit' &&
              <div
                className="displayed-value"
                lang={secretLanguage}
                contentEditable={interactionState === 'edit'}
                suppressContentEditableWarning
                dangerouslySetInnerHTML={{
                  __html: sanitizeCell(currentCard.secret),
                }}
                onBlur={(e) => setEditSecret(sanitizeCell(e.target.innerHTML))}
              />
            }
            <VocabularyTools
              rowIndex={0}
              side="right"
              vocabulary={mockVocabulary}
              readOnly={interactionState !== 'edit'}
              displayTools={displayTools}
              onTranslationResult={setEditSecret}
            />
          </div>
        </div>
        <div className={`card cover ${coverPosition}`} onClick={showSecret} data-testid="show">
          <center>
            {interactionState === 'showQuestion' && (
              <KeyboardArrowDown className="question-arrow-down" />
            )}
          </center>
        </div>
      </div>
    </div>
  )
}

export default CardsPlayCardDisplay
